import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

// 安全解析 localStorage
function safeParse(key, defaultValue) {
  try {
    const data = localStorage.getItem(key)
    return data ? JSON.parse(data) : defaultValue
  } catch (e) {
    return defaultValue
  }
}

export default new Vuex.Store({
  state: {
    token: Cookies.get('token') || '',
    userInfo: safeParse('userInfo', {}),
    storeId: localStorage.getItem('storeId') || ''
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      Cookies.set('token', token, { expires: 7 })
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      localStorage.setItem('userInfo', JSON.stringify(info))
      // 同时保存到 localStorage 供其他模块使用
      if (info.storeId) {
        localStorage.setItem('storeId', info.storeId)
      }
    },
    SET_STORE_ID(state, id) {
      state.storeId = id
      localStorage.setItem('storeId', id)
    },
    CLEAR_ALL(state) {
      state.token = ''
      state.userInfo = {}
      state.storeId = ''
      Cookies.remove('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('storeId')
    }
  },
  actions: {
    login({ commit }, data) {
      commit('SET_TOKEN', data.token)
      commit('SET_USER_INFO', {
        staffId: data.staffId,
        staffNo: data.staffNo,
        realName: data.realName,
        role: data.role,
        storeId: data.storeId,
        storeName: data.storeName
      })
      commit('SET_STORE_ID', data.storeId)
    },
    logout({ commit }) {
      commit('CLEAR_ALL')
    }
  },
  getters: {
    isSuperAdmin: state => state.userInfo.role === 0,
    isStoreManager: state => state.userInfo.role === 1,
    isStaff: state => state.userInfo.role === 2
  }
})
